var map = {
	"./berlin.svg": 7799,
	"./bielefeld.svg": 2259,
	"./bremerhaven.svg": 3699,
	"./de.svg": 8610,
	"./en.svg": 8986,
	"./leaves_left.svg": 65,
	"./leaves_right.svg": 3260,
	"./nrw.svg": 3666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;